<template>
<div class="home">
<!--
  Home: {{ $store.getters.menu_heir($route) }}
  <p>{{$store.state.data.menus}}</p>
  <p v-for="(m,n) in $store.state.menu_lu">{{n}}:{{m}}</p>
-->
</div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    HelloWorld
  }
}
</script>
